import Mock from '@/mocks/Mock'
import Notifications from '@/models/Notifications'
import { NotificationsParams } from '@/repositories/notifications-repository'

export default class NotificationsMock extends Mock<Notifications> {
  constructor() {
    super('notifications')
  }

  fetch(params: NotificationsParams) {
    const items = params.afterId ? [] : this.data.items

    return new Notifications(items)
  }
}
